import { createTheme, responsiveFontSizes } from '@mui/material/styles';

import { components } from './components';
import { darkPalette, lightPalette } from './palette';
import { tokens } from './tokens';
import { typography } from './typography';

const baseTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-mui-color-scheme',
  },
  colorSchemes: {
    light: { palette: lightPalette },
    dark: { palette: darkPalette },
  },
  shape: { borderRadius: tokens.radius.md },
  spacing: tokens.spacing,
  typography,
  components,
});

// `responsiveFontSizes` rescales the variants we declared in `typography.ts`
// across the configured breakpoints so headlines aren't oversized on phones.
// Caps the upper bound (factor: 2) and starts shrinking at `sm`.
export const theme = responsiveFontSizes(baseTheme, {
  breakpoints: ['sm', 'md', 'lg'],
  factor: 2,
});

export type AppTheme = typeof theme;
